export default __webpack_public_path__ + "static/media/todos.a50b1691.png";